import React, { useEffect, useState } from "react";
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";


export type ToolbarPersonalizadaProps = {
  mostraFontSize?: boolean;
  mostraColorPicker?: boolean;
  mostraList?: boolean;
  mostraTextAlign?: boolean;
  mostraLink?: boolean;
  mostraImage?: boolean;
  mostraEmbedded?: boolean;
  mostraRemove?: boolean;
  mostraFontFamily?: boolean;
  mostraBlockType?: boolean;
  mostraBold?: boolean;
  mostraItalic?: boolean;
  mostraUnderline?: boolean;
  mostraStrikethrough?: boolean;
  mostraSuperscript?: boolean;
  mostraSubscript?: boolean;
  mostraCode?: boolean;


  mostraHistorico?: boolean; 
  mostraEmoji?: boolean;     
};

export type EditorDeTextoProps = {
  mensagem: string;
  onChange: (valor: string) => void;
  permitidoAlterarMensagem: boolean;
  toolbarHidden?: boolean;
  toolbarPersonalizada?: ToolbarPersonalizadaProps;
};

export const EditorDeTexto = (props: EditorDeTextoProps) => {
  const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(
    convertFromHTML(props?.mensagem ?? '').contentBlocks
  )));

  const onEditorStateChange = (state) => {
    setEditorState(state);
    props.onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  useEffect(() => {
    setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(
      convertFromHTML(props?.mensagem ?? '').contentBlocks
    )));
  }, [props.mensagem]);

  const personalizarToolBar = () => {
    const toolbarSettings = props.toolbarPersonalizada || {};

    const elements = [
      { selector: '.rdw-fontsize-wrapper', show: toolbarSettings?.mostraFontSize ?? false },
      { selector: '.rdw-colorpicker-wrapper', show: toolbarSettings.mostraColorPicker ?? false },
      { selector: '.rdw-list-wrapper', show: toolbarSettings.mostraList ?? false },
      { selector: '.rdw-text-align-wrapper', show: toolbarSettings.mostraTextAlign ?? false },
      { selector: '.rdw-link-wrapper', show: toolbarSettings.mostraLink ?? false },
      { selector: '.rdw-image-wrapper', show: toolbarSettings.mostraImage ?? false },
      { selector: '.rdw-embedded-wrapper', show: toolbarSettings.mostraEmbedded ?? false },
      { selector: '.rdw-remove-wrapper', show: toolbarSettings.mostraRemove ?? false },
      { selector: '.rdw-fontfamily-wrapper', show: toolbarSettings.mostraFontFamily ?? false },
      { selector: '.rdw-block-wrapper', show: toolbarSettings.mostraBlockType  ?? false },
    ];

    elements.forEach(({ selector, show }) => {
      const element = document.querySelector(selector) as HTMLElement;
      if (element && !show) {
        element.style.display = 'none';
      }
    });
  };

  useEffect(() => {
    if (!(props.toolbarHidden ?? false) && props.toolbarPersonalizada)
      personalizarToolBar();
  }, [props.toolbarPersonalizada]);

  return (
    <div className="_px-3 _border _border-gray-300 _rounded-lg">
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={onEditorStateChange}
        readOnly={!props.permitidoAlterarMensagem}
        toolbarHidden={props.toolbarHidden ?? false}
        toolbar={!(props.toolbarHidden ?? false) && {
          options: ['inline', ...(props.toolbarPersonalizada?.mostraEmoji ? ['emoji'] : []), ...(props.toolbarPersonalizada?.mostraHistorico ? ['history'] : [])],
          inline: {
            options: [
              ...(props.toolbarPersonalizada?.mostraBold ? ['bold'] : []),
              ...(props.toolbarPersonalizada?.mostraItalic ? ['italic'] : []),
              ...(props.toolbarPersonalizada?.mostraUnderline ? ['underline'] : []),
              ...(props.toolbarPersonalizada?.mostraStrikethrough ? ['strikethrough'] : []),
              ...(props.toolbarPersonalizada?.mostraSuperscript ? ['superscript'] : []),
              ...(props.toolbarPersonalizada?.mostraSubscript ? ['subscript'] : []),
              ...(props.toolbarPersonalizada?.mostraCode ? ['code'] : []),
            ],
          },
          emoji: props.toolbarPersonalizada?.mostraEmoji ? {} : undefined,
          history: props.toolbarPersonalizada?.mostraHistorico
            ? { options: ['undo', 'redo'] }
            : undefined,
        }}
      />
    </div>
  );
};
